import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import {
    initializeKitsConversationInputSchema,
    type KitsConversationSession,
} from "@/features/kits-conversations";
import { type AuthState, resolveViewerProfileIdentity } from "@/lib/core/auth";
import {
    initializeKitsWebConversation,
    resumeKitsWebConversation,
} from "@/features/kits-conversations/index.server";

const bootstrapViewerChat = createServerFn({ method: "POST" }).handler(
    async (): Promise<{ authState: AuthState | null }> => ({
        authState: await resolveViewerProfileIdentity(),
    }),
);

export function viewerChatBootstrapQueryOptions() {
    return queryOptions({
        queryKey: ["viewer-chat-bootstrap"] as const,
        queryFn: () => bootstrapViewerChat(),
        staleTime: 5 * 60_000,
    });
}

export const initializeKitsConversation = createServerFn({ method: "POST" })
    .inputValidator((data) => initializeKitsConversationInputSchema.parse(data))
    .handler(async ({ data }): Promise<KitsConversationSession> =>
        initializeKitsWebConversation(data),
    );

export const resumeKitsConversation = createServerFn({
    method: "POST",
}).handler(async (): Promise<KitsConversationSession | null> =>
    resumeKitsWebConversation(),
);
